module.exports = __webpack_public_path__ + "img/Master Guardian II.110c10bf.png";